import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { TRA_CUSTOM_04_Schema } from './TRA_CUSTOM_04_Schema';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(TRA_CUSTOM_04_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['Training', 'getTraCustom04R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraCustom04R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      TRA_CUSTOM_04_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Training.getTraCustom04R2, params);
  }, successOptions);
};

export const useSearch3 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(TRA_CUSTOM_04_Schema.mapper.search3);

  const query = useQuery({
    queryKey: ['Training', 'getTraCustom04R3', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Training.getTraCustom04R3, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch4 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      TRA_CUSTOM_04_Schema.mapper.search4,
      context
    );
    return apiRequest('post', Global.urls.Training.getTraCustom04R4, params);
  }, successOptions);
};

export const useSave1 = (options = {}) => {
  return useSaveMutation(async ({ rows, isEtcEduType }) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_04_Schema.mapper.save1, {
      isEtcEduType,
    });

    return apiRequest('post1', Global.urls.Training.saveTraCustom04U1, payload);
  }, options);
};

export const useSave2 = (options = {}) => {
  return useSaveMutation(async ({ rows, tpmId }) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_04_Schema.mapper.save2, {
      tpmId,
    });
    return apiRequest('post1', Global.urls.Training.saveTraCustom04U2, payload);
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_04_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.Training.deleteTraCustom04D1,
      payload
    );
  }, options);
};
export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, TRA_CUSTOM_04_Schema.mapper.delete2);
    return apiRequest(
      'post1',
      Global.urls.Training.deleteTraCustom04D2,
      payload
    );
  }, options);
};
